/**
 * @module contracts/contract
 */

/**
 * @typedef {module:utils/model~Model} Model
 * @typedef {{}} Tasks
 * @typedef {Model} Prototype
 * @typedef {Tasks|Prototype} Contract
 */
import model from '../utils/model.js'
import object from '../utils/object.js'

/**
 * The contract prototype (check only)
 * @type {Prototype}
 * @mixin
 */
export const prototype = model(Symbol('contract'))

/**
 * The contract selectors key
 * @type {Symbol}
 */
export const selectors = Symbol('contract.selectors')

/**
 * Returns a contract
 * @param {Tasks} tasks
 * @returns {Contract}
 */
export default (
  { ...tasks }
) => {
  tasks[selectors] = object(prototype, tasks[selectors])

  return object(prototype, tasks)
}
